<template>
  <div
    aria-label="Wird geladen…"
    class="spinner"
  />
</template>

<script>
export default {
  name: 'CSpinner'
}
</script>
